@if (mode === 'normal') {

  <div class="">

    <app-card padding="20" [showHeader]="false">
      @if (buttonPosition === 'top') {
        <ng-container *ngTemplateOutlet="buttonFilter"></ng-container>
        <br />

        <mat-divider></mat-divider>
        <br />
      }

      <app-form-data-set
        #formComponent

        [config]="{fields: fields, hideSubmit: true}"
        [element]="valueRecord"

        (submitted)="onChangeValues($event)"
      />

      @if (buttonPosition === 'bottom') {
        <mat-divider></mat-divider>
        <br />
        <ng-container *ngTemplateOutlet="buttonFilter"></ng-container>
      }
    </app-card>


  </div>
}

<ng-template #buttonFilter>
  <div class="row">
    <div class="col-12 col-md-6">
      <button
        mat-flat-button color="success"
        class="mat-body f-w-500 w-full"
        (click)="submitAndSave()"
      >
        Aplicar y guardar
      </button>
    </div>

    <div class="col-6 col-md-3">
      <button
        mat-flat-button color="primary"
        class="mat-body f-w-500 w-full"
        (click)="submit()"
      >
        Aplicar
      </button>
    </div>



    @if (!hideClear) {
      <div class="col-6 col-md-3 ">
        <button
          mat-flat-button
          class="mat-body f-w-500 w-full bg-accent-50"
          (click)="clear()"
        >
          Limpiar
        </button>
      </div>
    }

  </div>
</ng-template>
